/**
 * Created by bflannery on 04/20/2021.
 */

var $ = require('jquery');
var BootstrapDialog = require('bootstrap-dialog');

function errorDialog () {
    // the purchaseBegin endpoint called for a one time purchase is done from unity and unity is not handling errors
    // for that call.
    // It would be nice if unity let this script here do all paypal stuff (including calling beginPurchase)
    BootstrapDialog.show({
        type: BootstrapDialog.TYPE_DANGER,
        title: '<h4 class=\'msg-ttl\'>Paypal Error</h4>',
        closable: false,
        message: 'Server error attempting PayPal payment!',
        draggable: false,
        buttons: [
            {
                icon: 'glyphicon glyphicon-shopping-cart',
                label: 'Close',
                cssClass: 'btn-primary center-block',
                action: function (popup) {
                    popup.close();
                    window.gameInstance.SendMessage('Engine', 'OnPaypalClose');
                }
            }
        ]
    }).getModalHeader().css('text-align', 'center');
}

/**
 * PayPal payment interface
 * Interacts with the Unity client
  */
var PayPal = module.exports = {
    // this call comes from unity PayPalWrapper.jslib
    paymentRequest: function (req) {
        const openPaypal = function (paypal) {
            window.open(paypal.url);
            window.gameInstance.SendMessage('Engine', 'OnPaypalClose');
        };
        req = JSON.parse(req);

        if (!req.subscription) {
            if (req.paypal) {
                openPaypal(req.paypal);
            }
        } else {
            $.post('/api/paypal/subscription/contract', req).done(openPaypal).fail(errorDialog);
        }
    },
    onClose: function () {
        $('#paypal-modal').modal('hide');
        window.gameInstance.SendMessage('Engine', 'OnPaypalClose');
    }
};

global.PayPal = PayPal;
